/**
 * Tasks: `tasks:` / `t:` / `task:` / `#`, by title or key (`WEB-4`, old prefixes too).
 * Backed by the local search index (PLAN §12.2) through `deps.client`
 * (`index/indexClient.js` on desktop, `index/webIndexClient.js` on web).
 */
import { SquareCheck } from 'lucide-react';
import { createIndexProvider } from '../index/indexProvider';

export const SPEC = Object.freeze({ id: 'tasks', kinds: ['task'], prefixes: ['tasks', 't', 'task'], sigils: ['#'], labelKey: 'palette.scope.tasks', icon: SquareCheck, order: 50, page: 'task-manager.panel', parentKind: 'board' });

/** @param {{ client: object }} deps */
export default function create(deps) {
  return createIndexProvider(SPEC, deps);
}
